module.exports = __webpack_public_path__ + "static/fonts/luengo-light-webfont.5829fda9.woff";